__turbopack_context__.v({
  "formHeader": "styles-module-scss-module__GT8Jhq__formHeader",
  "formSelectorInnerWrapper": "styles-module-scss-module__GT8Jhq__formSelectorInnerWrapper",
  "formSelectorItem": "styles-module-scss-module__GT8Jhq__formSelectorItem",
  "formSelectorItemAddon": "styles-module-scss-module__GT8Jhq__formSelectorItemAddon",
  "formSelectorList": "styles-module-scss-module__GT8Jhq__formSelectorList",
  "formSelectorWrapper": "styles-module-scss-module__GT8Jhq__formSelectorWrapper",
  "growingArrow": "styles-module-scss-module__GT8Jhq__growingArrow",
  "subtitleWrapper": "styles-module-scss-module__GT8Jhq__subtitleWrapper",
});
